<!-- APP--APP管理--版本配置 -->
<template>
  <div class="ver">
    <!-- 表单-当前版本 及 添加新版本 -->
    <div class="md-layout card-form">
      <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100" :style="{'padding-left':0}">
        <!-- 选择当前版本 -->
        <div class="md-layout-item md-size-40 left-layout-item md-xsmall-size-60" :style="{'padding-left':0}">
          <md-field>
            <label>{{$I18n("now_use_version")}}</label>
            <md-select v-model="curr_version">
              <md-option value="">{{$I18n("none")}}</md-option>
              <md-option v-for="item in tableData" :key="item.id" :value="item.id">{{item.ver}}</md-option>
            </md-select>
          </md-field>
        </div>
        <!-- 保存按钮,提交当前版本 -->
        <div class="md-layout-item" :class="{ 'right-item-div':$root.state.mobile }">
          <md-button @click="form_saveVersion" :class="{ 'right-button':$root.state.mobile }" class= "left-icon md-info">
            <md-icon>save</md-icon>
            {{$I18n("save")}}
          </md-button>
        </div>
      </div>
      <!-- 添加按钮,添加新版本 -->
      <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
        <div class="md-layout-item right-layout-item" :style="{'text-align':'right','padding-right':'0'}">
          <md-button @click="table_addNewVersion" class="md-info">
            {{$I18n("add")}}
          </md-button>
        </div>
      </div>
    </div>
    <!-- 表格 
      版本号
      更新方式 [1: 强制更新, 2: 用户选择]
      状态 [1: 开启, 2: 关闭]
      操作栏 [修改该版本, 删除该版本]
    -->
    <md-table v-model="tableData">
      <md-table-row slot="md-table-row" slot-scope="{ item }" >
        <md-table-cell :md-label="$I18n('ver_code')">{{ item.ver }}</md-table-cell>
        <md-table-cell :md-label="$I18n('rn_ver_num')">{{ item.rn_ver }}</md-table-cell>

        <md-table-cell :md-label="$I18n('force_update')">{{ item.force_name }}</md-table-cell>
        <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
        <md-table-cell :md-label="$I18n('operate')"  class="button-box">
          <md-button
            @click.stop
            @click="table_editVersion(item)"
            class="md-just-icon md-round md-info left-icon"
            ><md-icon>edit</md-icon></md-button
          >
          <md-button
            @click.stop
            @click="table_deleteVersion(item)"
            class="md-just-icon md-round md-danger md-info"
            ><md-icon>close</md-icon></md-button
          >
        </md-table-cell>
      </md-table-row>
      <md-table-empty-state slot="md-table-empty-state">
        {{$I18n("none_data")}}
      </md-table-empty-state>
    </md-table>
    <!-- 表格-翻页 -->
    <md-card-actions v-if="count > 0" md-alignment="space-between">
      <div class="total-page">
        <p class="card-category">{{$I18n("total" )}} : {{count}}</p>
      </div>
      <pagination v-model="pageNo" :per-page="pageSize" :total="count" type= "info" class="pagination-no-border right-button" />
    </md-card-actions>
    <!-- 弹窗 {删除弹窗居中, 其余的在右侧} -->
    <modal key="main" v-show="modal" @close="modal_closeModal" :type="modalType == 'delete' ?'' :'rightModal'" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体-确认删除的弹窗 -->
      <template v-if="modalType === 'delete'" slot="body">
        <div>{{$I18n("is_sure_del")}}</div>
      </template>
      <!-- 弹窗-主体-添加/修改的弹窗 -->
      <template v-else-if="modalType === 'add' || modalType === 'edit'" slot="body">
        <!-- 表单 -->
        <div class=" md-layout"> 
          <!-- 表单-选择框-更新方式 -->
          <modal-form-item :label='$I18n("force_update_select")' class="md-layout-item md-size-50">
            <md-field>
              <md-select v-model="modalData.force">
                <md-option :value="1">{{$I18n("force")}}</md-option>
                <md-option :value="2">{{$I18n("user_select")}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 表单-输入框-版本号(3个输入框) {必填} -->
          <modal-form-item :label='$I18n("ver_code")' :required="true" class="md-layout-item md-size-50">
            <div class="md-layout">
              <md-field class="md-layout-item md-size-25">
                <md-input v-model="modalData.version_code[0]" :style="{'width':'100%'}"/>
              </md-field>
              <div class="md-layout-item md-size-5" :style="{'line-height':'60px'}">-</div>
              <md-field class="md-layout-item md-size-25">
                <md-input v-model="modalData.version_code[1]" :style="{'width':'100%'}"/>
              </md-field>
              <div class="md-layout-item md-size-5" :style="{'line-height':'60px'}">-</div>
              <md-field class="md-layout-item md-size-25">
                <md-input v-model="modalData.version_code[2]" :style="{'width':'100%'}"/>
              </md-field>
            </div>
          </modal-form-item>
          <!-- 表单-输入框-RN版本号(4个输入框) -->
          <modal-form-item :label='$I18n("rn_ver_num")' class="md-layout-item md-size-50">
            <div class="md-layout">
              <md-field class="md-layout-item md-size-15">
                <md-input v-model="modalData.rn_ver_code[0]" :style="{'width':'100%'}"/>
              </md-field>
              <div class="md-layout-item md-size-5" :style="{'line-height':'60px'}">-</div>
              <md-field class="md-layout-item md-size-15">
                <md-input v-model="modalData.rn_ver_code[1]" :style="{'width':'100%'}"/>
              </md-field>
              <div class="md-layout-item md-size-5" :style="{'line-height':'60px'}">-</div>
              <md-field class="md-layout-item md-size-15">
                <md-input v-model="modalData.rn_ver_code[2]" :style="{'width':'100%'}"/>
              </md-field>
              <div class="md-layout-item md-size-5" :style="{'line-height':'60px'}">-</div>
              <md-field class="md-layout-item md-size-15">
                <md-input v-model="modalData.rn_ver_code[3]" :style="{'width':'100%'}"/>
              </md-field>
            </div>
          </modal-form-item>
          <!-- 表单-按钮-添加新的详情信息 -->
          <div class="md-layout-item md-size-50" :style="{'text-align':'left','padding-left':'28px'}">
            <md-button @click="modal_addNewVersionDetail" class="md-info">
              {{$I18n("add_detail_info")}}
            </md-button>
          </div>
          <!-- 表单(详情信息) -->
          <div v-for="(item, index) in modalData.details" :key="index" class="md-layout-item md-size-100">
            <md-card>
              <md-card-content>
                <div class="md-layout">
                  <!-- 表单(详情信息)-按钮-删除该详情信息 -->
                  <div :style="{'position': 'absolute', 'right': '0', 'top': '-26px'}">
                    <md-button 
                      @click="modalData.details.splice(index,1)"
                      class="md-primary md-sm md-info right-button md-just-icon md-round">
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                  <!-- 表单(详情信息)-输入框-标题 -->
                  <div class="md-layout-item md-layout md-size-50">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'padding-left': '12px'}">
                      {{$I18n("oat_title")}}:
                    </label>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <md-input v-model="item.title"/>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单(详情信息)-输入框-URL -->
                  <div class="md-layout-item md-layout md-size-50">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'padding-left': '12px'}">
                      {{$I18n("oat_url")}}:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field>
                        <md-input v-model="item.url"/>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item md-layout md-size-50">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'padding-left': '12px'}">
                      RN URL:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field>
                        <md-input v-model="item.rn_url"/>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单(详情信息)-选择框-语言 -->
                  <!-- <div :class="item.lang === 'other' ?'md-size-50' :'md-size-100'" class="md-layout-item md-layout" :style="{'transition': 'none'}"> -->
                  <div class="md-size-50 md-layout-item md-layout" :style="{'transition': 'none'}">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'padding-left': '12px'}">
                      {{$I18n("lang")}}:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field>
                        <md-select v-model="item.lang">
                          <md-option v-for="langItem in langSelect" :key="langItem.value" :value="langItem.value">
                            {{langItem.name}}
                          </md-option>
                          <md-option :value="'other'">{{$I18n("other_lang")}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单(详情信息)-输入框-其他语言 {只在语言选择'其他语言'时才出现} -->
                  <div v-if="item.lang === 'other'" class="md-layout-item md-layout md-size-50">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'padding-left': '12px'}">
                      {{$I18n("lang")}}:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field>
                        <md-input v-model="item.inp_lang"/>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单(详情信息)-按钮-展示/隐藏说明 -->
                  <div class="md-layout-item md-layout md-size-100">
                    <md-button @click="item.showContent = !item.showContent" class="md-info">
                      {{item.showContent ?$I18n("hide") :$I18n("show")}}
                    </md-button>
                  </div>
                  <!-- 表单(详情信息)-输入框-说明 {富文本框} -->
                  <div v-if="item.showContent" class="md-layout-item md-layout md-size-100">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("oat_content")}}:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field >
                        <md-textarea v-model="item.content"></md-textarea>
                      </md-field>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
import { Pagination } from "@/components";

export default {
  components: {
    Modal,
    Pagination,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
  },
  watch:{
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  data(){
    return {
      data    : [], // 表格数据 (原始数据)
      count   : 0,  // 数据总数
      pageNo  : 1,  // 现在显示的页面的页数
      pageSize: 10, // 每页显示的数量
      curr_version: "", // 当前版本

      modal     : false, // 是否打开弹窗
      modalTitle: "",    // 弹窗标题
      modalType : "",    // 弹窗类型
      modalData : {      // 弹窗中的表单显示数据
        force: 1,
        state: 2,
        ver  : "",
        version_code: ["","",""],
        details: [],
        rn_ver_code: ["","","",""],
        rn_ver: "",
      },

      langSelect : [ // 选择语言 (常用的)
        {
          value : "en",
          name  : this.$I18n("en"),
        },{
          value : "zh-CN",
          name  : this.$I18n("zh-CN"),
        },{
          value : "zh-TW",
          name  : this.$I18n("zh-TW"),
        },
      ],
    }
  },
  computed:{
    tableData () { // 表格数据 (处理后数据)
      return [...this.data]
        .splice((this.pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          let force_name = "";
          switch (item.force) {
            case 1: // 强制更新
              force_name = this.$I18n("force") 
              break;
            case 2: // 用户选择
              force_name = this.$I18n("user_select")
              break;
            default:
              force_name = this.$I18n("unknow_state")
              break;
          }
          let state_name = "";
          switch (item.state) {
            case 1: // 开启
              state_name = this.$I18n("open") 
              break;
            case 2: // 关闭
              state_name = this.$I18n("close")
              break;
            default:
              state_name = this.$I18n("unknow_state")
              break;
          }
          return {
            ...item,
            force_name,
            state_name,
          }
        })
    },
  },
  methods: {
    table_addNewVersion(){ // 表格-点击打开 添加新的Version 的弹窗
      this.modal = true;
      this.modalTitle = this.$I18n("add");
      this.modalType = "add";
      this.modalData = {
        force: 1,
        state: 2,
        ver  : "",
        version_code: ["","",""],
        rn_ver_code: ["","","",""],
        rn_ver: "",
        details: [
          {
            lang     : "en",
            title    : "",
            url      : "",
            rn_url   : "",
            content  : "",
            inp_lang : "",
            showContent:false,
          }
        ],
      }
    },
    table_editVersion(item){ // 表格-点击打开 修改Version 的弹窗
      this.modal = true;
      this.modalTitle = this.$I18n("edit");
      this.modalType = "edit";
      this.$api.appVerQuery({id : item.id})
        .then((res) => {
          this.modalData = {
            ...item,
            ...res.data,
            version_code : res.data.ver.split("."),
            rn_ver_code : res.data.rn_ver ?res.data.rn_ver.split(".") :["","","",""],
            details : res.data.details ?[...res.data.details.map(detail => {
              let inp_lang = "";
              if(!this.langSelect.map(item => {return item.value}).includes(detail.lang)){
                inp_lang = detail.lang;
              }
              return {
                ...detail,
                lang : inp_lang ?"other" :detail.lang,
                showContent: false,
                inp_lang,
              }
            })] :[],
          }
        })
    },
    table_deleteVersion(item){ // 表格-点击打开 删除Version 的弹窗
      this.modal = true;
      this.modalTitle = this.$I18n("tips");
      this.modalType = "delete";
      this.modalData = {...item};
    },
    form_saveVersion(){ // 表单-修改当前版本
      if(this.tableData.length === 0){
        this.$successMsg(this.$I18n("add_success"));
        return 
      }
      let sendData = this.tableData.filter(item => {
        return this.curr_version == item.id
      })[0];
      this.$api.editAppVer({ // api: /ota/app/ver/modify
        ...sendData,
        state: 1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.api_getVersion();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_addNewVersionDetail () { // 弹窗-新增 新的 "新版本详情" 栏
      this.modalData.details.push({
        lang    : "en",
        title   : "",
        rn_url  : "",
        url     : "",
        content : "",
        inp_lang: "",
        showContent:false,
      })
    },
    modal_submit(){ // 弹窗-提交弹窗表单的内容
      switch(this.modalType){
        case "add":   // 添加 
          this.api_Version();
          break;
        case "edit":  // 修改
          this.api_Version();
          break;
        case "delete":// 删除
          this.api_deleteVersion();
          break;
      }
    },
    api_Version(){ // API-添加/修改选中的版本的内容
      if (this.modalData.version_code.some(i => !i)) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      let sendData = {
        ...this.modalData,
        app_id  : this.app_id,
        ver     : this.modalData.version_code.join('.'),
        rn_ver  : this.modalData.rn_ver_code.filter(i => i).join('.'),
        details : this.modalData.details.map(detail => {
          return {
            ...detail,
            lang : detail.lang === 'other' ?detail.inp_lang :detail.lang
          };
        })
      }
      if(this.modalType === "add"){ // 添加
        this.$api.addAppVer(sendData) // api: /ota/app/ver/add
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("add_success"));
            this.modal_closeModal();
            this.api_getVersion();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      } else if (this.modalType === "edit") { // 修改
        this.$api.editAppVer(sendData) // api: /ota/app/ver/modify
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.modal_closeModal();
            this.api_getVersion();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
    },
    api_deleteVersion(){ // API-删除选中的版本
      return this.$api.delAppVer(this.modalData) // api: /ota/app/ver/delete
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.modal_closeModal();
          this.api_getVersion();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getVersion (){ // API-获取对应 APP ID 下的所有版本
      return this.$api.appVerListQuery({ // api: /ota/app/ver/query
        page_no:0,
        page_size:0,
        app_id: this.app_id,
      })
        .then(this.$Then(res => {
          let useVer = res.data.filter(item => item.state === 1)[0];
          this.curr_version = useVer ?useVer.id :""
          this.data  = res.data;
          this.count = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.curr_version = ""
          this.data = [];
          this.count = 0;
        }))
    },
  },
  created(){
    this.api_getVersion();
  },
}
</script>
<style lang="css" scoped>
  .md-form-label{
    text-align: left !important;
  }
</style>
<style type="scss" scoped>
  .ver{
    padding-top: 20px;
  }
  .right-item-div{
    padding: 0;
  }
  .right-button{
    margin-right: 0!important;
  }
</style>